export const labDevBaseUrl = 'http://192.168.100.88:8090'
export const labProdBaseUrl = 'https://lab.kinan.sa'
export const clientDevBaseUrl = 'http://192.168.100.88:8095'
export const clientProdBaseUrl = 'https://kinan.sa'

export const oAuthBaseUrl = '/api/v1/kinan-oauth'
export const userRegisterUrl = '/register'
export const userLoginUrl = '/login'
export const issueTokenUrl = '/issue-token'

export const clinicsBaseUrl = '/api/v1/kinan-clinics'
export const clientsBaseUrl = '/api/v1/kinan-clients'
export const doctorsBaseUrl = '/api/v1/kinan-doctors'
export const patientsBaseUrl = '/api/v1/kinan-patients'
export const ordersBaseUrl = '/api/v1/kinan-orders'

export const createUrl = '/create'
export const createItemUrl = '/create/item'
export const submitUrl = '/submit'

export const doctorUid = localStorage['DOCTOR-UID']
export const clientUid = localStorage['CLIENT-UID']

const token = localStorage['KINAN-X-AUTH-TOKEN']

export const getRequest = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Authorization: `Bearer ${token}`
  }
}

export const postRequest = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Authorization: `Bearer ${token}`
  }
}

export const putRequest = {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Authorization: `Bearer ${token}`
  }
}

export const deleteRequest = {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    Authorization: `Bearer ${token}`
  }
}
